import React, { useState, useEffect, useCallback } from 'react';
import { db } from '../firebase'; // 👈 Sube un nivel desde GlobalComponentes/ hacia src/
import { collection, getDocs, doc, updateDoc } from 'firebase/firestore';

export default function PortalGlobalPagos() {
  const [listaEdificios, setListaEdificios] = useState([]);
  const [edificioSeleccionado, setEdificioSeleccionado] = useState('');
  const [datosHistorico, setDatosHistorico] = useState([]);
  const [anioFiltro, setAnioFiltro] = useState('2026');
  const [mesFiltro, setMesFiltro] = useState('Todos');
  const [cargando, setCargando] = useState(false);

  const meses = ['Todos', 'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];

  // Obtener la lista de edificios al cargar el componente
  useEffect(() => {
    const cargarEdificios = async () => {
      try {
        const snapshot = await getDocs(collection(db, 'edificios_mmdl'));
        const edificios = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
        setListaEdificios(edificios);
        if (edificios.length > 0) {
          setEdificioSeleccionado(edificios[0].id);
        }
      } catch (error) {
        console.error("Error al cargar edificios en portal global:", error);
      }
    };
    cargarEdificios();
  }, []);

  // Obtener los registros históricos del edificio seleccionado
  const cargarHistoricoEdificio = useCallback(async () => {
    if (!edificioSeleccionado) return;
    try {
      setCargando(true);
      const refHistorico = collection(db, `historico_${edificioSeleccionado}`);
      const snapshot = await getDocs(refHistorico);
      const lista = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
      
      // Ordenar por departamento de forma numérica/alfanumérica
      lista.sort((a, b) => (parseInt(String(a.departamento).replace(/\D/g, '')) || 0) - (parseInt(String(b.departamento).replace(/\D/g, '')) || 0));
      setDatosHistorico(lista);
    } catch (error) {
      console.error("Error al cargar histórico del edificio:", error);
      setDatosHistorico([]);
    } finally {
      setCargando(false);
    }
  }, [edificioSeleccionado]);

  useEffect(() => {
    if (edificioSeleccionado) {
      cargarHistoricoEdificio();
    }
  }, [edificioSeleccionado, cargarHistoricoEdificio]);

  const formatearMonto = (v) => `S/ ${parseFloat(String(v).replace(/[^0-9.-]+/g, "") || 0).toFixed(2)}`;

  // Función inteligente para alternar (aprobar o deshacer) el estado de pago
  const toggleAprobarPagoGlobal = async (item) => {
    const esAprobado = item.estadoPago === "Pago verificado y aprobado ✅";
    const nuevoEstado = esAprobado 
      ? (item.voucherUrl ? "En revisión por administración" : "Pendiente de validación")
      : "Pago verificado y aprobado ✅";

    const mensaje = esAprobado 
      ? `⚠️ ¿Deshacer la aprobación del pago del Dpto. ${item.departamento} (${item.nombre})? El estado regresará a su color normal.`
      : `¿Estás seguro de aprobar el pago del Dpto. ${item.departamento} (${item.nombre}) en este edificio?`;

    if (window.confirm(mensaje)) {
      try {
        const refDoc = doc(db, `historico_${edificioSeleccionado}`, item.id);
        await updateDoc(refDoc, { estadoPago: nuevoEstado });
        await cargarHistoricoEdificio();
        if (esAprobado) {
          alert(`⚠️ ¡Aprobación deshecha! El estado del Dpto. ${item.departamento} volvió a la normalidad.`);
        } else {
          alert(`✅ ¡Pago del Dpto. ${item.departamento} aprobado con éxito!`);
        }
      } catch (error) {
        console.error("Error al actualizar estado de pago:", error);
        alert("❌ Ocurrió un error al intentar actualizar el pago.");
      }
    }
  };

  // Filtrar por año y mes
  const datosFiltrados = datosHistorico.filter(item => {
    const coincideAnio = String(item.anio || '') === String(anioFiltro);
    const coincideMes = mesFiltro === 'Todos' || String(item.mes || '').trim().toLowerCase() === mesFiltro.toLowerCase();
    return coincideAnio && coincideMes;
  });

  return (
    <div style={{ textAlign: 'left' }}>
      <h3 style={{ color: '#1e293b', marginTop: 0 }}>💰 Auditoría y Validación de Pagos por Edificio</h3>
      <p style={{ color: '#64748b', fontSize: '0.9rem', marginBottom: '20px' }}>
        Selecciona un edificio y periodo para revisar los vouchers subidos por los propietarios y validar su estado de pago.
      </p>

      {/* Controles de Filtro */}
      <div style={{ backgroundColor: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '8px', padding: '15px 20px', marginBottom: '20px', display: 'flex', gap: '15px', flexWrap: 'wrap', alignItems: 'center' }}>
        <div>
          <label style={{ fontWeight: 'bold', fontSize: '0.9rem' }}>🏢 Edificio:</label>
          <select 
            value={edificioSeleccionado} 
            onChange={e => setEdificioSeleccionado(e.target.value)} 
            style={{ marginLeft: '8px', padding: '6px', fontWeight: 'bold', borderRadius: '6px', border: '1px solid #cbd5e1' }}
          >
            {listaEdificios.map(edif => (
              <option key={edif.id} value={edif.id}>{edif.nombre}</option>
            ))}
          </select>
        </div>

        <div>
          <label style={{ fontWeight: 'bold', fontSize: '0.9rem' }}>📅 Año:</label>
          <select 
            value={anioFiltro} 
            onChange={e => setAnioFiltro(e.target.value)} 
            style={{ marginLeft: '8px', padding: '6px', fontWeight: 'bold', borderRadius: '6px', border: '1px solid #cbd5e1' }}
          >
            {['2024','2025','2026','2027','2028','2029','2030'].map(a => <option key={a} value={a}>{a}</option>)}
          </select>
        </div>

        <div>
          <label style={{ fontWeight: 'bold', fontSize: '0.9rem' }}>🗓️ Mes:</label>
          <select 
            value={mesFiltro} 
            onChange={e => setMesFiltro(e.target.value)} 
            style={{ marginLeft: '8px', padding: '6px', fontWeight: 'bold', borderRadius: '6px', border: '1px solid #cbd5e1' }}
          >
            {meses.map(m => <option key={m} value={m}>{m}</option>)}
          </select>
        </div>
      </div>

      {/* Tabla de Pagos / Historial */}
      {cargando ? (
        <p style={{ textAlign: 'center', padding: '30px', color: '#64748b' }}>Cargando pagos del edificio...</p>
      ) : (
        <div style={{ overflowX: 'auto' }}>
          <table className="tabla-propietarios">
            <thead>
              <tr>
                <th>Dpto.</th>
                <th>Propietario</th>
                <th>Periodo (Mes / Año)</th>
                <th>Cuota</th>
                <th>Voucher del Propietario</th>
                <th>Estado / Validar Pago</th>
              </tr>
            </thead>
            <tbody>
              {datosFiltrados.length === 0 ? (
                <tr>
                  <td colSpan="6" style={{ textAlign: 'center', padding: '30px', color: '#666' }}>
                    No hay registros de pagos para los filtros seleccionados en este edificio.
                  </td>
                </tr>
              ) : (
                datosFiltrados.map(item => {
                  const esAprobado = item.estadoPago === "Pago verificado y aprobado ✅";

                  return (
                    <tr key={item.id}>
                      <td><strong>{item.departamento}</strong></td>
                      <td>{item.nombre}</td>
                      <td><strong>{item.mes || '-'} / {item.anio || '-'}</strong></td>
                      <td>{formatearMonto(item.cuota)}</td>
                      <td>
                        {item.voucherUrl ? (
                          <a 
                            href={item.voucherUrl} 
                            target="_blank" 
                            rel="noopener noreferrer" 
                            style={{ backgroundColor: '#0284c7', color: 'white', padding: '5px 10px', borderRadius: '4px', fontSize: '0.8rem', fontWeight: 'bold', textDecoration: 'none', display: 'inline-block' }}
                          >
                            👁️ Ver Voucher ↗
                          </a>
                        ) : (
                          <span style={{ color: '#d9534f', fontStyle: 'italic', fontWeight: 'bold' }}>Sin voucher</span>
                        )}
                      </td>
                      <td>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                          <span style={{ 
                            backgroundColor: esAprobado ? '#f3e8ff' : (item.voucherUrl ? '#dcfce7' : '#fef3c7'), 
                            color: esAprobado ? '#6b21a8' : (item.voucherUrl ? '#166534' : '#d97706'), 
                            padding: '3px 6px', 
                            borderRadius: '4px', 
                            fontWeight: 'bold', 
                            fontSize: '0.75rem', 
                            textAlign: 'center',
                            border: esAprobado ? '1px solid #d8b4fe' : 'none'
                          }}>
                            {item.estadoPago || 'Pendiente'}
                          </span>
                          
                          <div style={{ display: 'flex', gap: '4px' }}>
                            <button 
                              onClick={() => toggleAprobarPagoGlobal(item)}
                              style={{ 
                                backgroundColor: esAprobado ? '#7c3aed' : '#16a34a', 
                                color: 'white', 
                                border: 'none', 
                                padding: '5px 6px', 
                                borderRadius: '4px', 
                                fontSize: '0.7rem', 
                                fontWeight: 'bold', 
                                cursor: 'pointer', 
                                flex: 1 
                              }}
                              title={esAprobado ? "Deshacer aprobación" : "Aprobar pago"}
                            >
                              {esAprobado ? "Deshacer ↩️" : "Aprobar ✔️"}
                            </button>
                          </div>
                        </div>
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}